<theme-root *ngIf="show" [buildNumber]="buildNumber"></theme-root>
